export default "__VITE_ASSET__bf0d549d__"